import fingerprintjs2 from "fingerprintjs2";
import { setLocalData } from "@/utils/storage";

export const useFingerprint2 = () => {
	/**
	 * 获取设备标识方式
	 */
	const initFingerprint2 = () => {
		fingerprintjs2.get({}, function (components: any[]) {
			const values = components.map(function (component) {
				return component.value;
			});
			const murmur = fingerprintjs2.x64hash128(values.join(""), 31);
			// 设置设备标识
			setLocalData("fingerprint", murmur);
		});
	};

	return {
		initFingerprint2
	};
};
